import React from "react";
import { Link } from "react-router-dom";
function Cropcountheader(props) {
  return (
    <div className="shadow px-2 py-1  text-sm grid grid-cols-3 items-center mx-5 my-2">
      <p className="font-medium text-sm text-center underline col-start-2 underline-offset-4 decoration-slate-800">
        {props.heading}
      </p>
      <div className="flex justify-end">
        <Link to="/dashboard">
          <div className=" font-medium text-sm text-center underline col-start-2 underline-offset-4 decoration-slate-800">
            View Dashboard
          </div>
        </Link>
      </div>
    </div>
  );
}

export default Cropcountheader;
